var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolesPermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10Z",
    fill: "#19943c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 16C10 15.66 10.03 15.33 10.08 15.01C10.05 15 10.03 15 10 15C8.03 15 6.1 15.53 4.41 16.54C4.16 16.68 4 17 4 17.35V18H10.29C10.1 17.37 10 16.7 10 16Z",
    fill: "#19943c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18V17.35C4 17.01 4.16 16.69 4.41 16.54C6.1 15.53 8.03 15 10 15C10.03 15 10.05 15 10.08 15.01C10.18 14.31 10.38 13.64 10.67 13.03C10.45 13.01 10.23 13 10 13C7.58 13 5.32 13.67 3.39 14.82C2.51 15.34 2 16.32 2 17.35V20H11.26C10.84 19.4 10.51 18.72 10.29 18H4ZM10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6Z",
    fill: "#19943c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8299 12.63L19.3799 13.12C19.0599 12.85 18.6999 12.64 18.2999 12.49L17.9999 11H15.9999L15.6999 12.49C15.2999 12.64 14.9399 12.85 14.6199 13.12L13.1699 12.63L12.1699 14.36L13.3099 15.36C13.2799 15.57 13.2499 15.77 13.2499 15.99C13.2499 16.21 13.2799 16.41 13.3099 16.62L12.1699 17.62L13.1699 19.35L14.6199 18.86C14.9399 19.13 15.2999 19.34 15.6999 19.49L15.9999 21H17.9999L18.2999 19.51C18.6999 19.36 19.0599 19.15 19.3799 18.88L20.8299 19.37L21.8299 17.64L20.6899 16.64C20.7199 16.43 20.7499 16.23 20.7499 16.01C20.7499 15.79 20.7199 15.59 20.6899 15.38L21.8299 14.38L20.8299 12.63ZM16.9999 18C15.8999 18 14.9999 17.1 14.9999 16C14.9999 14.9 15.8999 14 16.9999 14C18.0999 14 18.9999 14.9 18.9999 16C18.9999 17.1 18.0999 18 16.9999 18Z",
    fill: "#19943c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesPermissions);
export default __webpack_public_path__ + "static/media/roles-permissions.3e98814e.svg";
export { ForwardRef as ReactComponent };